export class Stop {
    id: number;
    title: string;
    address: string;
    map: string;
    lat: string;
    lng: string;

    constructor(title: string, address: string, map: string, lat: string, lng: string) {
        this.title = title;
        this.address = address;
        this.map = map;
        this.lat = lat;
        this.lng = lng;
    }
}
